import type { Channel } from "@/api_client";

import type { EnvironmentInfo } from "../types/types";

const getEnvironmentInfo = (channel: Channel): EnvironmentInfo => {
  return {
    businessArea: "PRI",
    country: "Finland",
    portfolio: "if.fi",
    partner: mapChannelToPartnerName(channel),
  };
};

const mapChannelToPartnerName = (channel: Channel) => {
  if (channel === "NU") {
    return "Nordea";
  }
  return undefined;
};

export default {
  getEnvironmentInfo,
};
